import _ from 'lodash';

import PostConstants from './PostConstants';

export function posts(state = {}, action) {
    switch (action.type) {
        case PostConstants.POST_RECEIVED:
            return {
                ...state,
                [action.payload.id]: {
                    id: action.payload.id.toString(),
                    account_id: action.payload.account_id.toString(),
                    integration_id: action.payload.integration_id,
                    integration_type: action.payload.integration_type,
                    status: action.payload.status,
                    message: action.payload.message,
                    media: action.payload.media,
                    scheduled_for: action.payload.scheduled_for,
                    published_at: action.payload.published_at,
                    created_at: action.payload.created_at,
                    updated_at: action.payload.updated_at,

                    replies: action.payload.replies,
                }
            };
            break;
        case PostConstants.POST_REMOVED:
            return _.pickBy(state, post => post.id !== action.payload.id );
            break;
        case PostConstants.POST_SHARED:
            return {
                ...state,
                [action.payload.id]: {
                    ...state[action.payload.id],
                    status: 'shared',
                    published_at: action.payload.published_at
                }
            };
            break;
        case PostConstants.POST_SCHEDULED:
            return {
                ...state,
                [action.payload.id]: {
                    ...state[action.payload.id],
                    status: 'scheduled',
                    scheduled_for: action.payload.schedule
                }
            };
            break;

        case PostConstants.POST_UNSCHEDULED:
            return {
                ...state,
                [action.payload.id]: {
                    ...state[action.payload.id],
                    status: 'draft',
                    scheduled_for: null
                }
            };
            break;
        default:
            return state;
    }
}
